import { render, staticRenderFns } from "./groupedWall.vue?vue&type=template&id=3f8bc021&scoped=true&"
import script from "./groupedWall.vue?vue&type=script&lang=js&"
export * from "./groupedWall.vue?vue&type=script&lang=js&"
import style0 from "./groupedWall.vue?vue&type=style&index=0&id=3f8bc021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bc021",
  null
  
)

export default component.exports